import logo from "/asset/MySoft_Quickbill_logo_500x300.png";
import PrivacyPolicyContent from "@/components/PrivacyPolicyContent";
import { rootVars } from "@/components/landing";
import MarketingScrollArea from "@/components/MarketingScrollArea";
import "@/components/landing.css";

/**
 * Standalone Privacy Policy page at /privacy-policy.
 *
 * The text itself lives in PrivacyPolicyContent so that the landing page
 * footer dialog and this page always render the same wording. The chrome
 * reuses the landing page design tokens and the .qb-landing stylesheet so
 * that the two surfaces look like one site.
 */
const PrivacyPolicyView = () => {
  return (
    <div className="qb-landing" style={rootVars}>
      {/* NAV - mirrors the landing page nav (dark in both themes) */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "18px",
          flexWrap: "wrap",
          padding: "14px clamp(20px,4vw,56px)",
          background: "rgba(11,18,32,.92)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255,255,255,.08)",
        }}
      >
        <a
          href="/"
          aria-label="QuickBill home"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={logo}
            alt="QuickBill"
            style={{ height: "30px", width: "auto", display: "block" }}
          />
        </a>
        <a
          className="qb-navlink"
          href="/"
          style={{
            color: "#94a3b8",
            fontSize: "14px",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Back to QuickBill
        </a>
      </div>

      {/* HEADER BAND */}
      <div
        style={{
          padding: "clamp(44px,6vw,72px) clamp(20px,7vw,120px) clamp(28px,3vw,40px)",
          background: "var(--bg2)",
          borderBottom: "1px solid var(--line)",
        }}
      >
        <div style={{ maxWidth: "880px", margin: "0 auto" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "clamp(30px,3.6vw,46px)",
              fontWeight: 800,
              letterSpacing: "-1px",
              lineHeight: 1.12,
              color: "var(--ink)",
            }}
          >
            Privacy Policy
          </h1>
        </div>
      </div>

      {/* BODY */}
      <div
        style={{
          padding: "clamp(36px,5vw,56px) clamp(20px,7vw,120px) clamp(56px,7vw,88px)",
          background: "var(--bg)",
        }}
      >
        <div style={{ maxWidth: "880px", margin: "0 auto" }}>
          <PrivacyPolicyContent
            className="space-y-5 text-[15px] leading-[1.75] text-slate-600 [&_h2]:pt-5 [&_h2]:text-[19px] [&_h2]:font-extrabold [&_h2]:tracking-tight [&_h2]:text-slate-900 [&_h3]:pt-1 [&_h3]:text-[15px] [&_h3]:font-bold [&_h3]:text-slate-800 [&_ul]:pl-6"
          />
        </div>
      </div>

      {/* FOOTER - condensed version of the landing page footer */}
      <div
        style={{
          background: "#0b1220",
          padding: "26px clamp(20px,7vw,120px)",
          borderTop: "1px solid rgba(255,255,255,.08)",
        }}
      >
        <div
          style={{
            maxWidth: "880px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
            flexWrap: "wrap",
            fontSize: "12.5px",
            color: "#475569",
          }}
        >
          <span>
            &copy; 2026 PowerTree Solution Sdn. Bhd. All Rights Reserved.
          </span>
          <a
            className="qb-footlink"
            href="/"
            style={{ color: "#94a3b8", textDecoration: "none" }}
          >
            Back to QuickBill
          </a>
        </div>
      </div>
    </div>
  );
};

/** Privacy policy page inside the shared overlay-scrollbar container. */
const PrivacyPolicyPage = () => (
  <MarketingScrollArea>
    <PrivacyPolicyView />
  </MarketingScrollArea>
);

export default PrivacyPolicyPage;
